import { reducer as listCategoryReducer } from './listCategory.slice';

export default listCategoryReducer;
